export const SELECTED_USERS_STORAGE_KEY = 'selected-users'

export default store => {
  store.subscribe((mutation, { meetings }) => {
    if (mutation.type === 'SELECT_CALENDAR_USERS' ||
        mutation.type === 'TOGGLE_CALENDAR_USER') {
      window.localStorage.setItem(SELECTED_USERS_STORAGE_KEY, JSON.stringify(meetings.selectedUsers))
    }
  })
}



// WEBPACK FOOTER //
// ./src/vuex/plugins/meeting.js